<template>
  <div class="brands brand-view">
    <HeroBlock v-bind="hero"></HeroBlock>
    <div class="block">
      <CardBlock :cards="cards"></CardBlock>
      <DescriptionBlock v-bind="description"></DescriptionBlock>
      <LikeBlock v-bind="like"></LikeBlock>
    </div>
    <Toggle :cards="cards" :description="description" :like="like"></Toggle>
    <ComModal :promise="promise" style="padding-bottom: 80px"></ComModal>

    <Developing v-if="0"></Developing>
  </div>
</template>

<script>
import HeroBlock from "@/components/hero-block";
import CardBlock from "@/components/cards-block";
import DescriptionBlock from "@/components/description-block";
import LikeBlock from "@/components/like-block";
import Toggle from "@/components/toggle";
import ComModal from "@/components/commercial-modal";
import Developing from "../components/developing-block";
export default {
  components: {
    HeroBlock,
    CardBlock,
    DescriptionBlock,
    LikeBlock,
    Toggle,
    ComModal,
    Developing
  },
  data() {
    return {
      hero: {
        title: `Программа поощрения покупок <br>
        по всей стране.`,
        paragraphs: [
          `Система регистрирует приобретение конкретного продукта в любой точке страны. <br>
          Программа при помощи полного распознавания кассовых чеков находит нужный <br>
          товар и его стоимость в любой покупке.`,
          `Производитель, минуя всех посредников, получает возможность обратиться <br>
          напрямую к конечному покупателю его продукции. Система позволяет узнать <br>
          все о своем потребителе, рассказать покупателям о новостях и предложить бонус.`,
          `Программа работает без установки приложений, без размещения кодов на упаковке <br>
          без выпуска карт – акция запускается без каких-либо дополнительных усилий. <br>
          В системе сразу предусмотрены разные механики: программа лояльности, <br>
          регистрация купонов для проведения розыгрышей, прямое поощрение покупки <br>
          мгновенным подарком.`
        ],
        src: require(`@/assets/images/hero4.png`)
      },
      cards: [
        {
          title: `Прямой диалог с потребителем`,
          paragraph: `Система позволяет вести диалог с конечным потребителем вашей продукции. Сначала, покупатели отвечают на вопросы <br>
          анкеты при первой регистрации покупки. В дальнейшем, чат-боты общаются с клиентами, собирая важную информацию <br>
          о покупательских привычках и желаниях. Чат-бот является полноценным порталом проводимой акции, и позволяет <br>
          не только узнавать информацию об акции, но и регистрировать покупки, писать отзывы, выбирать призы и т.д.`,
          src: require(`@/assets/images/card-FMCG1.svg`)
        },
        {
          title: `Настройка уникальных диалогов`,
          paragraph: `Программа способна общаться с покупателями по-разному. Потребители разделяются на группы по определенным <br>
          признакам, гендер, возраст, потребительская привычка, география и т.д. Для каждой группы в системе создаются <br>
          отдельные ветки диалогов, прописываются шутки, предлагаются специальные акции. Для оживления общения <br>
          чат-бот в одной и той же точке диалога использует разные реплики. Эффективность таких тонко настроенных <br>
          коммуникаций гораздо выше, чем применение единого шаблона для всех категорий клиентов.`,
          src: require(`@/assets/images/card-FMCG2.svg`)
        },
        {
          title: `Гибкость и универсальность`,
          paragraph: `Клиент получает доступ ко всем возможностям программы независимо от выбранного им канала коммуникации. <br>
          Регистрация проходит лишь однажды, в дальнейшем система «узнаёт» клиента и в чат-ботах, и в веб-формах акции. <br>
          Система легко настраивается под любую механику и уже содержит необходимые инструменты – суммирование <br>
          или дробление сумм чеков, разные категории покупок для многоуровневого начисления бонусов, витрину призов, <br>
          алгоритмы бронирования и выдачи подарков и т.д.`,
          src: require(`@/assets/images/card-FMCG3.svg`)
        },
        {
          title: `Точность, безопасность и скорость`,
          paragraph: `Система проверяет подлинность и состав полученных чеков в налоговой службе. Только после подтверждения <br>
          подлинности чеки проходят регистрацию в системе. Отдельные чеки из случайной выборки регулярно <br>
          проверяются сотрудниками «вживую». На сегодняшний день программа обрабатывает 96% чеков в течение <br>
          30 секунд, еще 3% в течение 4 часов, и менее 1% чеков проверяется в течение 24 часов с момента загрузки <br>
          в систему.`,
          src: require(`@/assets/images/card-FMCG4.svg`)
        }
      ],
      description: {
        title: `Эффективная статистика`,
        paragraphs: [
          `Подробные отчеты о ходе акции доступны организатору круглосуточно в личном <br>
          кабинете и обновляются в реальном времени. Программа высчитывает точные <br>
          показатели аудитории, формирует географические и временные карты покупок, <br>
          вычисляет основные маркетинговые показатели.`,
          `Разделы статистики собираются, как конструктор, поэтому отчеты при необходимости <br>
          могут быть дополнены специфическими данными и показателями.`
        ],
        src: require(`@/assets/images/description4.svg`)
      },
      like: {
        title: `Юридическая чистота`,
        paragraph: `Сбор, хранение и обработка персональных данных осуществляется в соответствии с законодательством РФ. Организаторам стимулирующих акций <br>
        собранные данные передаются в обезличенном виде в формате подробных электронных отчетов. С организатора акции снимаются все риски <br>
        столкновения с контролирующими органами, ответственность за работу с персональными данными клиентов несет исполнитель.`,
        src: require(`@/assets/images/like4.svg`)
      },
      promise: ` Обещаем присылать не более четырех писем в месяц с обзором наших новых возможностей, <br>
      продуктов, предложения`
    };
  }
};
</script>